import { render, staticRenderFns } from "./points-used-record.vue?vue&type=template&id=1d8d347e&scoped=true"
import script from "./points-used-record.vue?vue&type=script&lang=js"
export * from "./points-used-record.vue?vue&type=script&lang=js"
import style0 from "./points-used-record.vue?vue&type=style&index=0&id=1d8d347e&prod&scoped=true&lang=css"
import style1 from "./points-used-record.vue?vue&type=style&index=1&id=1d8d347e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8d347e",
  null
  
)

export default component.exports